import { useWorkspace } from "@/api/auth/queries";
import { Button } from "../ui/button";
import { ShoppingCart } from "lucide-react";
import { cn } from "@/helpers/tailwind";
import { useConnectToStoreModal } from '@/contexts/ConnectToStoreProvider';

type Props = {
  children?: React.ReactNode;
  className?: string;
  variant?:
    | "default"
    | "destructive"
    | "outline"
    | "secondary"
    | "ghost"
    | "link"
    | null
    | undefined;
};

const ShopifyBillingButton = ({ children, className, variant }: Props) => {
  const workspace = useWorkspace();
  const { openModal } = useConnectToStoreModal();

  const handleChangePlan = () => {
    //admin.shopify.com/store/{store_handle}/charges/{app_handle}/pricing_plans
    if (!workspace || !workspace.shop_url) {
      // replaced the toast with opening the modal
      openModal();
      return;
    }
    window.open(
      `https://admin.shopify.com/store/${workspace.shop_url.replace(".myshopify.com", "")}/charges/boudraw-ai-customer-support/pricing_plans`,
      "_blank"
    );
  };

  return (
    <Button
      variant={variant}
      className={cn("", className)}
      onClick={handleChangePlan}>
      {children || (
        <>
          <ShoppingCart className="mr-2 h-5 w-5" />
          Manage with Shopify Billing
        </>
      )}
    </Button>
  );
};

export default ShopifyBillingButton;
